<template>
  <div class="bill-wrap1" v-loading="extractLoading">
    <div class="bill-header">
      <div>
        <div class="flex-wrap">
          <h3>
          </h3>
          <!-- <el-radio-group v-model="type" size="mini" @change="typeChange">
            <el-radio label="票据识别" border>票据识别</el-radio>
            <el-radio label="银行卡" border>银行卡</el-radio>
            <el-radio label="身份证" border>身份证</el-radio>
            <el-radio label="营业执照" border>营业执照</el-radio>
            <el-radio label="小语种" border>小语种</el-radio>
          </el-radio-group> -->
        </div>
        <div style="font-size: 15px;">
          <div style="display: flex;align-items: center;">
            <div v-show="fileName">文件名： <span style="font-weight: 600;margin-right: 20px;">{{fileName}}</span></div>
            <el-upload v-if="uploadURL" v-show="fileName" class="upload-demo"
              accept=".jpeg,.jpg,.png,.JPG,.PNG,.pdf,.PDF,.doc,.docx,.xls,.xlsx,.DOC,.DOCX,.XLS,.XLSX,.tif,.tiff" :auto-upload="true" :action="uploadURL"
              :on-success="uploadSuccess" :headers="uploadHeaders" :before-upload="beforeUpload"
              :on-change="uploadChange" :on-error="uploadError">
              <el-button size="small" type="primary">重新上传</el-button>
            </el-upload>
            <!-- <el-button style="margin-left: 10px;" size="mini" class="el-icon-thumb" type="success"
              @click="extractFn([], 'click')"> 抽取</el-button> -->

            <el-dropdown @command="commandFn" style="margin-left:5px">
              <el-button type="primary">
                抽取<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="chatGPT">调用ChatGPT</el-dropdown-item>
                <el-dropdown-item command="deepSeek">调用deepSeek</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div
      style="display: flex;justify-content:flex-end;margin-right: 20px;font-size: 13px;margin-bottom: 5px;margin-top: 5px;">
      <div v-if="allImageList.length > 1">
        {{'第 '+(currPage + 1)+'/'+allImageList.length+' 页'}}
        <el-button type="primary" :disabled="currPage === 0" size="mini" icon="el-icon-arrow-left"
          @click="pageFn('prev')">上一页</el-button>
        <el-button type="primary" :disabled="currPage === allImageList.length - 1" size="mini"
          @click="pageFn('next')">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
    </div>
    <div class="content"
      :style="{'margin-top': type === '小语种' ? 0 : '20px', 'height': type === '小语种' ? 'calc(100% - 110px)' : 'calc(100% - 130px)'}">
      <template v-if="type === '票据识别'">
        <iframe width="100%" height="100%" src="https://ai.xiantaiai.com/ocr"></iframe>
      </template>
      <template v-else>
        <div class="left" v-loading="loading" element-loading-text="请耐心等待....">
          
          <!-- <img class="img-sty1" v-if="imgUrl" :src="imgUrl" /> -->
          <iframe width="100%" v-if="pdfBase64" height="100%" frameborder="0" scrolling="auto" :src="pdfBase64"></iframe>
          <el-image class="img-sty1" v-else-if="imgUrl" :src="imgUrl" lazy :preview-src-list="[imgUrl]"></el-image>

          <el-upload v-else accept=".jpeg,.jpg,.png,.JPG,.PNG,.pdf,.PDF,.doc,.docx,.xls,.xlsx,.DOC,.DOCX,.XLS,.XLSX,.tif,.tiff" class="upload-demo" drag :auto-upload="true"
            :action="uploadURL" :on-success="uploadSuccess" :before-upload="beforeUpload" :headers="uploadHeaders"
            :on-change="uploadChange" :on-error="uploadError">
            <div class="text">
              <i class="el-icon-upload"></i>
            </div>
            <div class="el-upload__text">将文件拖到此处，或<em> 点击上传</em></div>
            <div class="el-upload__tip" slot="tip">（支持拖拽上传），且不超过10mb</div>
          </el-upload>
        </div>
        <div class="right">
          <p @click="downloadFn" v-if="jsonData.length > 0 && activeName === 'ocr'" class="download-sty"><i
              class="el-icon-download"></i>导出识别结果</p>
          <p @click="copyExtractDataFn" v-if="resultText || JSON.stringify(extractData) !== '{}' && activeName === 'extract'" class="download-sty"><i
              class="el-icon-download"></i>复制抽取结果</p>
          <el-tabs v-model="activeName" class="yc-tabs" ref="tabs" type="card" style="margin: 20px;">
            <el-tab-pane label="OCR识别结果" name="ocr" key="ocr">
              <div class="search" v-if="jsonData.length > 0 && activeName === 'ocr'">
                <el-input style="margin-bottom: 10px;" placeholder="请输入关键字按回车键搜索" size="small"
                  prefix-icon="el-icon-search" v-model="inputOcr" @keyup.enter.native="searchChange"></el-input>
              </div>
              <div @wheel="onRightAreaScroll" id="right-area" class="ocr-result"
                :style="{'height': height + 'px','overflow-y': 'scroll','overflow-x': 'hidden'}">
                <template v-if="type === '小语种'">
                  <div class="ocr-result-wrap">
                    <template v-if="jsonData.length === 0">
                      <div class="noMsg"></div>
                    </template>
                    <template v-else>
                      <div>
                        <div class="row" style="margin-bottom: 10px;" v-for="(item,index) in jsonData[0]" ref="row"
                          :key="index">
                          <div style="display: inline-block; width:7%;color: #484949;font-size: 14px;">
                            <p>{{index+1}}</p>
                          </div>
                          <div style="display: inline-block;width:90%">
                            <span class="filed" @click="copyFn(x.words)" v-for="(x,i) in item" :key="i" ref="word"
                              v-html="x._char"></span>
                          </div>
                        </div>
                      </div>
                      <div class="buttonshib">
                        <!-- <el-button size="small" type="test" class="jiucbun" @click="errorjiuzhneg()" style="text-align: center;padding: inherit;float: right;margin-right: 30px;width: 124px;height: 32px;">识别结果纠错</el-button> -->
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="JSON结果" name="json" key="json">
              <template v-if="jsonData.length > 0 && activeName === 'ocr'">
                <div :style="{'height': height + 'px','overflow-y': 'scroll'}">
                  <json-viewer :show-double-quotes="true" :expanded="expanded" show-array-index :expand-depth="5"
                    copyable boxed :value="jsonData"></json-viewer>
                </div>
              </template>
            </el-tab-pane> -->
            <el-tab-pane label="抽取结果" name="extract" key="extract">
              <div v-if="btnFlag === 'chatGPT' || btnFlag === 'deepSeek'" @wheel="onRightAreaScroll" class="ocr-result-wrap extract-sty"
                :style="{'height': height + 50 + 'px','overflow-y': 'auto','background': '#f9f9f9'}">
                <div v-for="(value, key) in extractData" :key="key" class="field">
                  <span class="key">{{ key }}: </span>
                  <span class="value">{{ value }}</span>
                </div>
              </div>
              <!--
              <div v-if="btnFlag === 'deepSeek'" @wheel="onRightAreaScroll" class="ocr-result-wrap extract-sty"
                :style="{'height': height + 50 + 'px','overflow-y': 'auto','background': '#f9f9f9'}">
                <p v-html="resultText"
                  style="word-wrap: break-word; white-space: pre-wrap;line-height:20px;padding: 10px;"></p>
              </div>
              -->

            </el-tab-pane>
          </el-tabs>
          <i v-if="jsonData.length === 0" class="el-icon-document"></i>
        </div>
        <div class="extract-wrap">
          <el-input type="textarea" v-model="extractStr" placeholder="请输入抽取字段，格式如下：
发票号
发票日期(转YYYY-MM-DD格式)
发票金额
等...
抽取字段后面加英文括号为调优说明"></el-input>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import JsonViewer from 'vue-json-viewer/ssr'
  import 'vue-json-viewer/style.css'

  export default {
    props: {},
    data() {
      return {
        fileName: '请上传识别文件',
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
        ],
        activeName: 'ocr',
        uploadURL: this.$uploadFile.url,
        uploadHeaders: null,
        jsonData: [],
        allJsonData: [],
        allJsonDataObj: {},
        allImageList: [],
        currPage: 0,
        expanded: true,
        height: document.documentElement.clientHeight - 290,
        extractheight: document.documentElement.clientHeight - 250 + 'px',
        fileList: [],
        invoicesData: [],
        taxiTickets: [],
        trainTickets: [],
        volumeTickets: [],
        electricTickets: [],
        machineTickets: [],
        quotaInvoice: [],
        // 机票
        airTickets: [],
        busShipTickets: [],
        tollTickets: [],
        taxiOnlineTicket: [],
        fileName: '',
        imgUrl: '',
        pdfBase64: '',
        loading: false,
        type: '小语种',
        bankCard: [],
        langArr: [
          { name: '德语', value: 'EURO_ALL_ATT_GER' }, { name: '日语', value: 'JAP' }, { name: '韩语', value: 'KOR' }, { name: '法语', value: 'FRE' }, { name: '西班牙语', value: 'SPA' }, { name: '葡萄牙语', value: 'POR' }, { name: '意大利语', value: 'ITA' }, { name: '俄语', value: 'RUS' }, { name: '丹麦语', value: 'DAN' }, { name: '荷兰语', value: 'DUT' }, { name: '马来语', value: 'MAL' }, { name: '瑞典语', value: 'SWE' }, { name: '印尼语', value: 'IND' }, { name: '波兰语', value: 'POL' }, { name: '罗马尼亚语', value: 'ROM' }, { name: '土耳其语', value: 'TUR' }, { name: '希腊语', value: 'GRE' }, { name: '匈牙利语', value: 'HUN' }, { name: '泰语', value: 'THA' }, { name: '越南语', value: 'VIE' }, { name: '阿拉伯语', value: 'ARA' }, { name: '印地语', value: 'HIN' }
        ],
        selectedLang: 'EURO_ALL_ATT_GER',
        sessionId: '',
        extractStr: '',
        extractData: {},
        extractLoading: false,
        inputOcr: '',
        resultText: '',
        btnFlag: ''
      }
    },
    computed: {
    },
    components: {
      JsonViewer
    },
    watch: {
    },
    created() { },
    mounted() {
      // 依赖DashIndex.vue 中设置sessionStorage'BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN'
      setTimeout(() => {
        // 先获取官网token，在赋值
        this.uploadHeaders = this.$header()
      }, 500)
    },
    methods: {
      onRightAreaScroll(event) {
        // 阻止事件冒泡
        event.stopPropagation();
        // 处理右边区域的滚动逻辑
        //console.log('右边区域滚动');
      },
      beforeUpload(file) {
        this.loading = true
        //单个文件小于10M
        let size = file.size / 1024 / 1024
        const isLt2M = size < 10 && size !== 0

        if (size === 0) {
          this.$message.error('不支持空文件上传')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传失败，' + file.name + ' 大小超出10M')
          return false
        }
        return isLt2M
      },
      async uploadSuccess(response, file, fileList) {
        if (this.fileName) {
          this.extractStr = ''
          this.extractData = {}
          this.resultText = ''
          this.activeName = 'ocr'
        }
        this.bankCard = []
        this.jsonData = []
        if (response) {
          this.loading = false
          this.fileName = file.name
          this.$message.success('识别成功');

          // let _that = this;
          // if (file.name.toUpperCase().includes('.PDF')) {
          //   _that.imgUrl = ''
          //   // 创建一个新的 FileReader 对象
          //   var reader = new FileReader();
          //   // 定义读取完成时的回调函数
          //   reader.onload = function (event) {
          //     // 将文件内容转换为 Base64 编码
          //     var base64Content = event.target.result.split(',')[1]; // 获取 Base64 部分
          //     _that.pdfBase64 = 'data:application/pdf;base64,' + base64Content + '#view=FitH,top';
          //     // 在这里你可以对 base64Content 进行进一步处理，比如放入 iframe 中或上传至服务器等操作
          //   };
          //   // 读取文件内容，并以 Data URL 的形式返回
          //   reader.readAsDataURL(file.raw);
          // } else {
          //   this.imgUrl = this.getImg(file.raw); //图片地址
          //   this.pdfBase64 = ''
          // }

          if (response.status === 200) {
            this.currPage = 0
            this.allImageList = response.data.imageList
            this.imgUrl = this.allImageList[this.currPage].resPath
            
            let nameType = file.name.substr(file.name.lastIndexOf('.') + 1)
            //console.log(nameType + '--' + nameType);
            if (nameType === 'DOC' || nameType === 'DOCX' || nameType === 'doc' || nameType === 'docx' || 
                nameType === 'XLS' || nameType === 'XLSX' || nameType === 'xls' || nameType === 'xlsx') {
              //console.log('1=====' + 'https://view.officeapps.live.com/op/view.aspx?src=' + this.imgUrl);
              //console.log('2=====' + this.$utils.officeView + this.imgUrl)           
              this.pdfBase64 = this.$utils.officeView + this.imgUrl
            } else {
              this.pdfBase64 = ''
            }
            
            let res1 = await this.getOcrOriginData(response.data);
            let data = (response.code && response.code === 1) ? response.data : JSON.parse(response.data)
            this.jsonData = []
            this.allJsonData = this.convertObjectToArray(res1.data.data)
            this.allJsonDataObj = res1.data.data

            //console.log(this.allJsonData)
            for (let key in res1) {
              if (Array.isArray(data[key]) && data[key].length === 0) {
                delete res1[key];
              }
            }
            this.jsonData = [res1.data.data[0]]
            this.loading = false
            // this.extractFn(data)
          }
        } else {
          this.$router.replace({
            path: '/login'
          });
          this.$message.error('session过期，请重新登录')
        }
      },
      convertObjectToArray(obj) {
        return Object.keys(obj).map(key => obj[key]);
      },
      getOcrOriginData(val) {
        this.loading = true
        if (val === null || (val.imageList && val.imageList.length === 0)) {
          this.noData = true;
          return;
        }
        this.noData = false;

        let pathList = val.imageList.map(item => {
          return item.resPath;
        })
        let url = this.$resource.getOcrOriginData

        return this.$axios({
          url: url,
          method: 'post',
          data: {
            "imagePathList": pathList,
            "certiType": 3,
            "oriFilePath": '',
            'languageType': "CHN_ENG_BD"
          },
          transformResponse: [(data) => {

            let result = JSON.parse(data);
            let keys = Object.keys(result.data);
            if (keys[0] === 'msg') {
              return [];
            }
            keys.forEach(item => {
              result.data[item].forEach(x => {
                x.forEach(y => {
                  //新增属性，初始化备份单词;
                  y._char = y.words;
                })
              })
            });
            return result;
          }]
        })
      },
      uploadChange(file, fileList) {
        this.fileList = fileList
      },
      uploadError() {
        this.loading = false
      },
      handleClick() {

      },
      getImg(file) {
        let url = '';
        if (window.createObjectURL !== undefined) { // basic
          url = window.createObjectURL(file);
        } else if (window.URL !== undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }
        return url;
      },
      typeChange(e) {
        let that = this
        switch (e) {
          case '票据识别':
            that.uploadURL = that.$invoiceRecognitionUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '银行卡':
            that.uploadURL = that.$laiyOcrBankCardUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '身份证':
            that.uploadURL = that.$laiyOcrIdCardUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '营业执照':
            that.uploadURL = that.$laiyOcrLicenseUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '护照':
            that.uploadURL = that.$laiyOcrPassportUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '小语种':
            that.uploadURL = that.$uploadFile.url + `CHN_ENG_BD`;
            that.height = document.documentElement.clientHeight - 280 + 'px'
            that.selectedLang = 'EURO_ALL_ATT_GER'
            //that.getOCRSessionid()
            break;
          default:
            console.warn('Unknown type:', e);
        }

        // 重置数据
        this.invoicesDat = [];
        this.taxiTickets = [];
        this.trainTickets = [];
        this.volumeTickets = [];
        this.electricTickets = [];
        this.machineTickets = [];
        this.quotaInvoice = [];
        this.airTickets = [];
        this.busShipTickets = [];
        this.taxiOnlineTicket = [];
        this.imgUrl = '';
        this.fileName = '';
        this.pdfBase64 = ''
        this.jsonData = []
        this.invoicesData = []
        this.bankCard = []
      },
      getOCRSessionid() {
        this.$axios({
          url: 'https://api-aiocr.cloud-sh.com/v3/api/login',
          method: "post",
          data: {
            // 'userNo': "qianchui",
            // 'password': "qianchui@0520",
            'userNo': "hitisoft",
            'password': "hitisoft@0520",
            'loginInfo': "string"
          },
        }).then((res) => {
          if (res.data.data.code === "10000") {
            let data = res.data.data.data
            let sessionId = ''
            let arr = data.split('=')
            if (arr.length > 1) {
              sessionId = arr[1]
            }
          }
        });
      },
      pageFn(v) {
        this.extractData = {}
        this.resultText = ''
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 500);
        if (v === 'next') {
          this.imgUrl = this.allImageList[this.currPage + 1].resPath

          this.jsonData = [this.allJsonData[this.currPage + 1]]
          this.currPage++
        } else if (v === 'prev') {
          this.imgUrl = this.allImageList[this.currPage - 1].resPath
          this.jsonData = [this.allJsonData[this.currPage - 1]]
          this.currPage--
        }
        this.searchChange()
      },
      selectedLangChange(v) {
        this.uploadURL = this.$uploadFile.url + `${v}`;
        this.selectedLang = v
        this.jsonData = []
        this.pdfBase64 = ''
        this.imgUrl = ''
        this.fileName = ''
      },
      extractFn(data, flag, type) {
        this.extractData = {}
        this.resultText = ''
        // console.log(this.extractStr.trim().replace(/[\r\n]+/g, ','), 'jsonData')
        if (flag === 'click' && this.jsonData.length === 0) {
          return this.$message.error("请先上传文件！");
        }
        if (flag === 'click' && !this.extractStr.trim()) {
          return this.$message.error("请输入想抽取的字段！");
        }
        if (this.extractStr.trim()) {
          this.extractLoading = true
          this.activeName = 'extract'

          let url = '';
          if (type === 'chatGPT') {
            url = this.$resource.xwBigModelExtractDy + encodeURIComponent(this.extractStr.trim().replace(/[\r\n]+/g, ',')) + '&addition=根据关键字抽取'
          } else {
            url = this.$resource.dsAliBigModelExtract + encodeURIComponent(this.extractStr.trim().replace(/[\r\n]+/g, ',')) + '&addition=根据关键字抽取'
          }

          this.$axios({
            url: url,
            method: "post",
            data: this.allJsonDataObj,
          }).then((res) => {
            //console.log(res, 'res')
            if (res.data.code === 1) {
              if (this.btnFlag === 'chatGPT') {
                this.extractData = JSON.parse(res.data.data)
              } else {
                const textData = JSON.parse(res.data.data);
                if (textData.output) {
                  this.resultText = textData.output.choices[0].message.content
                } else {
                  //console.log(textData);
                  //this.resultText = textData;
                  /**
                  var jsonObject = JSON.parse(res.data.data);
                  let extractValueTem = '';
                  for (var key in jsonObject) {
                      if (jsonObject.hasOwnProperty(key)) {
                          var value = jsonObject[key];
                          extractValueTem += key + ':' + value + '\n';
                      }
                  }
                  this.resultText = extractValueTem;
                  */
                 this.extractData = JSON.parse(res.data.data);
                }
              }
              this.$message.success("抽取成功！");
            } else {
              this.extractData = {}
              this.$message.error(res.data.msg);
            }
            this.extractLoading = false
          }).then(() => {
            this.extractLoading = false
          })
        }
      },
      async copyExtractDataFn() {
        if (this.btnFlag === 'chatGPT' || this.btnFlag === 'deepSeek') {
          let extractValueTem = '';
          for (var key in this.extractData) {
              if (this.extractData.hasOwnProperty(key)) {
                  var value = this.extractData[key];
                  extractValueTem += key + ':' + value + '\n';                 
              }
          }
          //console.log(extractValueTem);
          await navigator.clipboard.writeText(extractValueTem)          
        } else {
          //console.log(this.resultText);
          if (this.resultText instanceof String) {
            await navigator.clipboard.writeText(this.resultText)
          } else {
            /**
            var jsonObject = JSON.parse(this.resultText);
            let extractValueTem = '';
            for (var key in jsonObject) {
                if (jsonObject.hasOwnProperty(key)) {
                    var value = jsonObject[key];
                    extractValueTem += key + ':' + value + '\n';
                }
            } */
            await navigator.clipboard.writeText(this.resultText)
          }
        }
      },
      searchChange() {
        let searchWord = this.inputOcr
        //console.log(this.jsonData[0], 666)
        //搜索高亮关键词
        this.jsonData[0].forEach(item => {
          item.forEach(x => {
            // 转换成大写，大小写都会搜索到
            let value = x.words
              .toUpperCase()
              .indexOf(searchWord.toUpperCase())
            if (value > -1) {
              // 截取单词前半部分
              x._char = x.words.slice(0, value)

              // 补充高亮部分
              for (
                let ii = value;
                ii < value + searchWord.length;
                ii++
              ) {
                x._char += '<em>' + x.words.charAt(ii) + '</em>'
              }

              // 截取单词后半部分
              let end = x.words.slice(
                value + searchWord.length,
                x.words.length
              )

              x._char += end
            } else {
              x._char = x.words
            }
          })
        })
        //自动定位
        this.$nextTick(() => {
          let ocrResult = document.querySelector('.ocr-result')
          let em = ocrResult.getElementsByTagName('em')
          if (em.length > 0) {
            ocrResult.scrollTop = em[0].offsetTop - 70
          }
        })
      },
      copyFn(v) {
        // 创建一个临时的文本区域元素
        const textarea = document.createElement('textarea');
        // 将传入的值赋给文本区域的值
        textarea.value = v;
        // 将文本区域元素添加到文档中
        document.body.appendChild(textarea);
        // 选择文本区域中的内容
        textarea.select();
        // 执行复制命令
        try {
          document.execCommand('copy');
          // 显示复制成功的消息
          this.$message.success('复制成功');
        } catch (err) {
          // 显示复制失败的消息
          this.$message.error('复制失败');
        }
        // 移除临时的文本区域元素
        document.body.removeChild(textarea);
      },
      downloadFn() {
        let url = this.$resource.exportOcrOriginData
        //console.log(this.imageItem)
        this.$axios({
          url: url,
          method: 'post',
          data: {
            imagePathList: [this.allImageList[this.currPage].resPath],
            certiType: 3,
            'languageType': "CHN_ENG_BD"
          }
        })
          .then(res => {
            this.$utils.exportFile(res.data, '导出识别结果', '.txt')
          })
          .catch(e => {
            console.log(e)
          })
      },
      commandFn(command) {
        this.btnFlag = command
        if (command === 'chatGPT') {
          this.extractFn([], 'click', 'chatGPT')
        } else if (command === 'deepSeek') {
          this.extractFn([], 'click', 'deepSeek')
        }
      }
    }
  }
</script>
<style>
  .bill-wrap1 {
    height: 100%;
    background: #fff;
    margin: 20px 10px 20px 20px;

    .filed {
      cursor: pointer;

      em {
        background: #ffe200;
      }

      .ocrLabel {
        width: 16px;
        height: 16px;
      }

      .ocrLabel:hover {
        color: #3d7fff;
        width: 16px;
        height: 16px;
      }

      .el-input__suffix {
        margin-right: 0px !important;

        .el-input__suffix-inner {
          margin-right: 0px !important;
        }
      }
    }

    .el-upload-list {
      display: none;
    }


    .bill-header {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid #ddd;

      >div:first-child {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }

      .flex-wrap {
        display: flex;
        align-items: center;
        width: 50%;

        .el-radio--mini.is-bordered {
          margin: 3px !important;
        }

        .el-radio__label {
          color: #333 !important;
          font-size: 13px;
        }
      }

      h3 {
        font-weight: 550;
        padding: 10px 0;
      }
    }

    .content {
      display: flex;
      margin: 20px;
      height: calc(100% - 130px);
      background-color: #f9f9f9;
      border-radius: 5px;

      .left {
        width: 60%;
        height: 100%;
        position: relative;
        overflow: hidden;

        .img-sty1 {
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          /* width: 80%; */
          height: 90%;
        }

        .upload-demo {
          margin: 20px;
          height: 100%;
        }

        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }

        .el-upload {
          width: 100%;
          height: calc(100% - 50px);

          .el-upload__text {
            position: absolute;
            top: 70%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          }
        }

        .el-upload-dragger {
          width: 100%;
          height: 100%;
          border-color: #ddd;
          position: relative;

          &:hover {
            border-color: #000000 !important;
          }

          .el-icon-upload {
            font-size: 130px;
          }
        }

        .el-upload__tip {
          text-align: center;
        }
      }

      >.right {
        /* border-left: 1px solid #ddd; */
        width: 40%;
        background-color: #f1f1f1;
        /* padding: 20px; */
        position: relative;

        .download-sty {
          font-size: 12px;
          color: #2f8d00;
          cursor: pointer;
          position: absolute;
          right: 10px;
          bottom: 10px;
        }

        .ocr-sty {
          overflow-y: scroll;
          background: #fff;
          border: 1px solid #eee;
          border-radius: 5px;

          .el-form-item {
            margin-bottom: 0 !important;
          }

          .el-form-item:first-child {
            .el-form-item__content {
              margin-left: 200px;
              font-size: 18px;
              color: #d30000;
              font-weight: 600;
            }
          }
        }

        .el-icon-document {
          color: #C0C4CC;
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          font-size: 6rem;
        }

        .el-form-item__label {
          color: #818181;
        }

        .el-form-item__content {
          color: #000;
        }
      }
    }
  }

  .el-image-viewer__wrapper {
    right: 45%;
  }

  .ocr-result-wrap .row span {
    display: inline-block;
    border: 1px solid #3d7fff;
    padding: 5px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #3d7fff;
    margin-right: 20px;
    white-space: pre-wrap;
    border-radius: 4px;
    margin-bottom: 5px;
  }

  .extract-wrap {

    .el-textarea,
    textarea {
      height: 100%;
      width: 100%;
      resize: none;
    }

    textarea {
      padding: 5px !important;
      font-family: "微软雅黑";
    }

    ::placeholder {
      color: #aaaaaa;
      font-size: 13px;
      font-family: "微软雅黑";
    }
  }

  .extract-sty {
    >div {
      padding: 10px 5px;
      font-size: 14px;
      font-family: "微软雅黑";
      line-height: 20px;
    }

    div:nth-child(odd) {
      background-color: #f9f9f9;
    }

    div:nth-child(even) {
      background-color: #e7f5ff;
    }
  }
</style>